// src/components/layout/MobileMenu.jsx - Updated with logo and Blogs link
import React from 'react';
import { Link } from 'react-router-dom';
import { X, ChevronRight, Home, Info, Briefcase, Heart, Phone, Cpu, BookOpen } from 'lucide-react';

const MobileMenu = ({ isOpen, onClose }) => {
  // If menu is not open, don't render anything
  if (!isOpen) return null;
  
  return (
    <div 
      className="fixed inset-0 z-50 backdrop-blur-sm" 
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}
    >
      <div 
        className="fixed inset-y-0 right-0 w-4/5 max-w-xs bg-white shadow-lg flex flex-col animate-slideIn"
        style={{ 
          maxWidth: '320px',
          animation: 'slideIn 0.3s ease-out forwards'
        }}
      >
        {/* Header with logo and close button */}
        <div className="p-4 border-b border-gray-200 flex justify-between items-center bg-gradient-to-r from-primary to-primary-dark">
          <div className="flex items-center">
            {/* Three vertical lines logo */}
            <div className="mr-2 flex space-x-1">
              <div className="h-5 w-1.5 rounded-full bg-accent"></div>
              <div className="h-7 w-1.5 rounded-full bg-accent"></div>
              <div className="h-5 w-1.5 rounded-full bg-accent"></div>
            </div>
            {/* Brand name */}
            <h2 className="text-xl font-bold text-white">
              <span className="text-white">AMV</span>
              <span className="text-accent"> LAW</span>
            </h2>
          </div>
          <button 
            onClick={onClose}
            className="p-2 rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        {/* Menu Items - With icons and improved styling */}
        <div className="flex-1 overflow-y-auto py-4">
          <nav className="px-4 space-y-2">
            <Link 
              to="/" 
              className="flex items-center px-3 py-3 text-base text-gray-700 hover:bg-gray-50 rounded-md transition-colors"
              onClick={onClose}
            >
              <Home className="h-5 w-5 text-primary mr-3" />
              <span>Home</span>
            </Link>
            
            {/* About Section */}
            <div className="py-1">
              <div className="flex items-center px-3 py-3 text-base text-gray-700 font-medium">
                <Info className="h-5 w-5 text-primary mr-3" />
                <span>About Us</span>
              </div>
              <div className="pl-11 space-y-1 mt-1">
                <Link
                  to="/about/firm"
                  className="flex items-center justify-between px-3 py-2 text-sm text-gray-600 hover:bg-gray-50 hover:text-primary rounded-md transition-colors"
                  onClick={onClose}
                >
                  <span>The Firm</span>
                  <ChevronRight className="h-4 w-4 text-gray-400" />
                </Link>
                <Link
                  to="/about/values"
                  className="flex items-center justify-between px-3 py-2 text-sm text-gray-600 hover:bg-gray-50 hover:text-primary rounded-md transition-colors"
                  onClick={onClose}
                >
                  <span>Our Values</span>
                  <ChevronRight className="h-4 w-4 text-gray-400" />
                </Link>
                <Link
                  to="/about/team"
                  className="flex items-center justify-between px-3 py-2 text-sm text-gray-600 hover:bg-gray-50 hover:text-primary rounded-md transition-colors"
                  onClick={onClose}
                >
                  <span>Team</span>
                  <ChevronRight className="h-4 w-4 text-gray-400" />
                </Link>
                <Link
                  to="/about/careers"
                  className="flex items-center justify-between px-3 py-2 text-sm text-gray-600 hover:bg-gray-50 hover:text-primary rounded-md transition-colors"
                  onClick={onClose}
                >
                  <span>Careers</span>
                  <ChevronRight className="h-4 w-4 text-gray-400" />
                </Link>
              </div>
            </div>
            
            {/* Services Section */}
            <div className="py-1">
              <Link
                to="/services"
                className="flex items-center px-3 py-3 text-base text-gray-700 hover:bg-gray-50 rounded-md transition-colors"
                onClick={onClose}
              >
                <Briefcase className="h-5 w-5 text-primary mr-3" />
                <span>Services</span>
              </Link>
            </div>
            
            {/* Blogs Section - New addition */}
            <Link
              to="/blogs"
              className="flex items-center px-3 py-3 text-base text-gray-700 hover:bg-gray-50 rounded-md transition-colors"
              onClick={onClose}
            >
              <BookOpen className="h-5 w-5 text-primary mr-3" />
              <span>Blogs</span>
            </Link>

            {/* Pro Bono Section */}
            <Link
              to="/pro-bono"
              className="flex items-center px-3 py-3 text-base text-gray-700 hover:bg-gray-50 rounded-md transition-colors"
              onClick={onClose}
            >
              <Heart className="h-5 w-5 text-secondary mr-3" />
              <span>Pro Bono Initiative</span>
            </Link>
            
            {/* AI Services */}
            <Link
              to="/ai-services"
              className="flex items-center px-3 py-3 text-base text-gray-700 hover:bg-gray-50 rounded-md transition-colors"
              onClick={onClose}
            >
              <Cpu className="h-5 w-5 text-primary mr-3" />
              <span>AI Services</span>
            </Link>
            
            {/* Contact Section */}
            <Link
              to="/contact"
              className="flex items-center px-3 py-3 text-base text-gray-700 hover:bg-gray-50 rounded-md transition-colors"
              onClick={onClose}
            >
              <Phone className="h-5 w-5 text-primary mr-3" />
              <span>Contact Us</span>
            </Link>
          </nav>
        </div>
        
        {/* Footer CTA */}
        <div className="p-4 bg-gray-50 border-t border-gray-200">
          <Link
            to="/contact"
            className="block w-full py-3 px-4 bg-gradient-to-r from-primary to-primary-dark text-white text-center font-medium rounded-md shadow-sm hover:from-primary-dark hover:to-primary-dark transition-colors"
            onClick={onClose}
          >
            Schedule a Consultation
          </Link>
        </div>
      </div>
    </div>
  );
};

// Add these keyframes to your CSS (src/index.css)
/*
@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
*/

export default MobileMenu;